<template>
  <portal to="modal" :disabled="!opened" :style="{ position: 'absolute' }">
    <ar-modal
      :is-open="opened"
      width="550px"
      :mobile="$arMediaQuery.window.maxWidth('xs')"
      hide-header
      hide-footer
      @close="handleModalClose"
      class="discard-changes-modal"
    >
      <div slot="body" class="discard-changes-modal__body">
        <div class="discard-changes-modal__content">
          <div class="discard-changes-modal__exclamation-mark">
            <ar-icon
              name="alert-exclamation-mark"
              height="60px"
            />
          </div>
          <ar-text size="md" weight="bold" :text="'Are you sure you want to discard changes?'" />
          <ar-text
            multiple-lines
            size="xs"
            class="u-margin-top-2"
            align="center"
            text="The changes you’ve made will be lost"
          />
        </div>
        <div class="discard-changes-modal__footer">
          <ar-simple-button text="Yes, discard" @click="handleConfirmOffAb" />
          <ar-link-button
            text="Cancel"
            @click="handleModalClose"
            :style="{
            height: '40px',
            padding: '0 20px'
          }"
          />
        </div>
      </div>
    </ar-modal>
  </portal>
</template>

<script>

export default {
  name: 'DiscardChangesModal',
  components: {

  },
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },

  methods: {
    handleModalClose() {
      this.$emit('close');
    },
    handleConfirmOffAb() {
      this.$emit('confirm');
    },
  }
};
</script>

<style lang="scss" scoped>
.discard-changes-modal {
  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px 48px 34px;
  }
  .ab-designs {
    display: flex;
    gap: 32px;
    margin-top: 24px;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
  }
  &__exclamation-mark {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }
}
</style>
